import {
  FETCH_MIPS_REPORT,
  FETCH_MIPS_REPORT_ERROR,
  FETCH_MIPS_REPORT_SUCCESS,
} from './mips.types'

export const fetchMipsReport = (params) => ({
  type: FETCH_MIPS_REPORT,
  payload: params,
})

export const fetchMipsReportSuccess = (data) => ({
  type: FETCH_MIPS_REPORT_SUCCESS,
  payload: data,
})

export const fetchMipsReportError = (error) => ({
  type: FETCH_MIPS_REPORT_ERROR,
  payload: error,
})
